module.exports = __webpack_public_path__ + "img/checkbox-marked.ea62ba81.svg";